
import helpers from '../components/helpers'

const US_COUNTRY_ID = 21 // Country::USA

const getDefaultCountry = () => {
    const region = window?.accuvars?.region
    if (region === 'us') {
        return US_COUNTRY_ID
    }
    return process.env.MIX_DEFAULT_COUNTRY_ID || 17 // Country::DEFAULT_COUNTRY
}

const productQuoteForm = (product) => ({
    ...helpers,
    ...window.helpers,
    industry: '',
    industry_other: '',
    description: '',
    minimum: 0,
    minimum_quote: 0,
    maximim_stock: 0,
    productId: product,
    quantity: 0,
    name: '',
    email: '',
    phone: '',
    company: '',
    country: 0,
    state: '',
    fieldKeys: ['quantity', 'name', 'email', 'phone', 'company', 'country', 'state', 'description', 'industry', 'industry_other'],
    each_formatted: '',
    total_formatted: '',
    buttonHeld: false,
    heldTimout: null,

    init() {
        this.quantity = parseInt(this.minimum_quote, 10)
        this.name = window.Alpine.store('user').firstname ? `${window.Alpine.store('user').firstname} ${window.Alpine.store('user').lastname}` : ''
        this.email = window.Alpine.store('user').email || ''
        this.phone = window.Alpine.store('user').phone || ''
        this.company = window.Alpine.store('user').company || ''
        this.description = ''
        this.industry = ''
        this.industry_other = ''
        this.country = getDefaultCountry()
        this.state = ''
        this.errors = {}
    },

    updateStock($event) {
        if ($event.detail.id_product !== this.productId) {
            return
        }

        this.stockAndPrice = $event.detail

        const maxBreak = $event.detail.price_breaks.reduce((prev, current) => (
            current.from_quantity > prev.from_quantity ? current : prev
        ))

        this.minimum = $event.detail.minimal_quantity
        this.maximum_stock = Math.max($event.detail.quantity, $event.detail.ex_stock, $event.detail.secondary_stock)
        this.minimum_quote = this.maximum_stock > 0 ? Math.min(maxBreak.from_quantity * 2, this.maximum_stock + 1) : maxBreak.from_quantity * 2

        if ($event.detail.price === 0 || !$event.detail.available_for_order) {
            this.minimum = 1
            this.minimum_quote = 1
        }

        this.quantity = this.minimum_quote

        this.reactToQuantityUpdate()
    },

    reactToQuantityUpdate() {
        const currentBreak = this.stockAndPrice.price_breaks.reduce((prev, current) => (
            current.from_quantity <= this.quantity && (current.from_quantity > prev.from_quantity || prev.from_quantity > this.quantity) ? current : prev
        ))

        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: this.stockAndPrice.currency_iso_code,
        })

        this.total_formatted = formatter.format((currentBreak.price || this.stockAndPrice.price) * this.quantity)
        this.each_formatted = currentBreak.price_formatted || this.stockAndPrice.price_formatted
    },

    submitForm() {
        const action = '/api/productquote'

        this.initAndExecuteGoogleCaptcha(action).then((token) => {
            const formData = new FormData()

            formData.append('captcha_token', token)
            formData.append('captcha_action', action)
            formData.append('product_id', product)
            formData.append('country', this.country)
            formData.append('state', parseInt(this.country, 10) === US_COUNTRY_ID ? this.state : '')
            formData.append('quantity', this.quantity)
            formData.append('name', this.name)
            formData.append('email', this.email)
            formData.append('phone', this.phone)
            formData.append('company', this.company)
            formData.append('industry', this.industry)
            formData.append('industry_other', this.industry === 'other' ? this.industry_other : '')
            formData.append('description', this.description)

            if (window.Alpine.store('gclid').gclid !== null && window.Alpine.store('gclid').utl !== null && new Date().getTime() < window.Alpine.store('gclid').utl) {
                formData.append('offline_tracking_gclid', window.Alpine.store('gclid').gclid)
            }

            this.submitting = true
            this.errors = {}

            window.api.post(action, formData).then((response) => {
                if (response.data.success === true) {
                    this.submitting = false
                    this.successfulSubmission = true
                    this.init()

                    window.dispatchEvent(new CustomEvent('gtmdata', {
                        detail: {
                            event: 'gtm_quote',
                        },
                    }))
                } else {
                    this.processServersideErrors(response.data)
                }
            }).catch((error) => {
                this.submitting = false
                this.successfulSubmission = false
                this.processServersideErrors(error.response.data)
            })
        })
    },
    changeQuantity(amount = 1) {
        let iterations = 0
        clearTimeout(this.heldTimout)
        this.heldTimout = null

        const change = () => {
            this.quantity = Math.max(this.minimum, this.quantity + amount)
            this.reactToQuantityUpdate()

            const delay = 1500 / (iterations + 3)
            iterations += 1

            this.heldTimout = setTimeout(() => {
                if (this.buttonHeld) {
                    change()
                }
            }, delay)
        }

        change()
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('productQuoteForm', productQuoteForm)
})
